module.exports = __webpack_public_path__ + "static/assets/a77d7ed07c4715b2b580438d46a567b9.svg";